import { css } from '@emotion/react'
import clsx from 'clsx'
import { isValid } from 'date-fns'

import { parseDate } from '@/util/DateUtil'

type Props = {
  label: string
  name: string
  onSelect: (option: Record<string, string | boolean>) => void
  type?: 'boolean' | 'date'
  value: boolean | string
}

export const FilterOption: React.FC<Props> = ({ label, name, value, type = 'boolean', onSelect }) => {
  const onBooleanChange = () => {
    onSelect({
      [name]: !value,
    })
  }

  const onDateChange = (event) => {
    const dateString = event.target.value
    const date = parseDate(dateString, 'yyyy-MM-dd')
    onSelect({ [name]: dateString, active: isValid(date) })
  }

  switch (type) {
    case 'boolean':
      return (
        <button className="flex items-center w-full py-3 px-4" css={hoverStyles} onClick={onBooleanChange}>
          <div className="mr-3">
            <EmptyCircle>{value && <FilledCircle />}</EmptyCircle>
          </div>
          <div className={clsx('flex-1 text-left text-label-sm', value && 'text-text-link')}>{label}</div>
        </button>
      )
    case 'date':
      return (
        <div className="flex flex-col" css={hoverStyles}>
          <label className="text-label-sm text-grey-500" htmlFor={name}>
            {label}
          </label>
          <input
            className="rounded-lg  border-2 border-grey-100 px-3 py-2 focus:outline-none"
            name={name}
            onChange={onDateChange}
            placeholder="Select Date"
            type="date"
            value={(value as string | null) || ''}
          />
        </div>
      )
    default:
      return null
  }
}

const hoverStyles = css`
  &:first-child:hover {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  &:hover {
    background-color: #f3f3f2;
  }
`

const EmptyCircle = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={clsx('border-2 border-action-primary flex items-center justify-center', className)}
    style={{ width: '20px', height: '20px', borderRadius: '50%' }}
  />
)

const FilledCircle = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    {...props}
    className={clsx('bg-action-primary', className)}
    style={{ width: '12px', height: '12px', borderRadius: '50%' }}
  />
)
